import React from 'react'
import { useHistory } from 'react-router-dom'

import './Subnav.css'

const SubnavMenuItem = ({ title, link, onSelect, isActive }) => (
    <div className="subnav-menu-item">
        <span
            onClick={onSelect(link)}
            className={`text ${isActive && 'active'}`}
        >
            {title}
        </span>
    </div>
)

const Subnav = ({ items }) => {
    const history = useHistory()

    const handleSelect = link => e => {
        e.preventDefault()
        e.stopPropagation()
        history.push(link)
    }

    return (
        <div className="subnav">
            <div className="subnav-menu">
                <div
                    className="subnav-menu-item"
                    style={{ paddingLeft: 0, marginLeft: 0 }}
                >
                    <span
                        onClick={() => history.push('/')}
                        className="text"
                        style={{ paddingLeft: 0, marginLeft: 0 }}
                    >
                        Home
                        <i
                            className="fa fa-chevron-right"
                            style={{
                                fontSize: 12,
                                color: 'lightgrey',
                                marginLeft: 6,
                            }}
                        />
                    </span>
                </div>
                {items.map(item => (
                    <SubnavMenuItem
                        key={item.title}
                        {...item}
                        onSelect={handleSelect}
                    />
                ))}
            </div>
        </div>
    )
}

export default Subnav
